/**
 * 我的小店-小店商品列表
 */
import _ from 'lodash'
import { getShopItemList } from '@/servers/commodity/index.js'
import { queryBaseItemDisplay } from '@/servers/base/display/index'


import { createNamespacedHelpers } from 'vuex'
const { mapState: mapState1, mapActions: mapActions1, mapGetters: mapGetters1 } = createNamespacedHelpers('commodityGoodsList')

export const mapState = mapState1;
export const mapActions = mapActions1;
export const mapGetters = mapGetters1;

const commodityGoodsList = {
    namespaced: true,
    state: () => ({
        list: [], // 列表数据
        selectedItems: [], // 当前所勾选的数据
        filterParams: {}, // 当前过滤项
        searchParams: {}, // 当前搜索条件
        sortParams: {}, // 当前排序条件
        pageParams: {
            pageNo: 1,
            pageSize: 20,
            total: 0
        }, // 当前页数
        displayRackClassifyList:[],
        freightModal: {
            visible: false,
            matchFreightRuleList: [],
        },
    }),
    mutations: {
        setList (state, list) {
            state.list = list
        },
        setSelectedItems (state, list) {
            state.selectedItems = list
        },
        setFilterParams (state, params) {
            state.filterParams = params
        },
        setSearchParams (state, params) {
            state.searchParams = params
        },
        setSortParams (state, params) {
            state.sortParams = params
        },
        setPageParams (state, params) {
            state.pageParams = params
        },
        setSelectedItems (state, items) {
            state.selectedItems = items
        },
        clear(state) {
            state.list = []; 
            state.selectedItems = []; 
            state.filterParams = {}; 
            state.searchParams = {}; 
            state.sortParams = {}; 
            state.pageParams = {
                pageNo: 1,
                pageSize: 20,
                total: 0
            }
        },
        setDisplayRackClassifyList (state, list) {
            state.displayRackClassifyList = list;
        },
        setFreightModalParams (state, params) {
            state.freightModal = {
                ...state.freightModal,
                ...params
            };
        },
    },
    actions: {
        clearList({commit}) {
            commit('clear')
        },
        fetchList({ commit, getters, dispatch }) {
            getShopItemList(getters.requestParams).then(res => {
                if (res) {
                    commit('setList', res.records)
                    dispatch('updatePageParams', {
                        total: res.total
                    })
                    commit('setSelectedItems', [])
                }
            })
        },
        updatePageParams({ commit, state }, payload = {}) {
            commit('setPageParams', {
                ...state.pageParams,
                ...payload
            })
        },
        updateFilterParams({ commit, dispatch }, payload = {}) {
            commit('setFilterParams', payload)
            dispatch("updatePageParams", {pageNo: 1})
            dispatch("fetchList")
        },
        updateSearchParams({ commit, dispatch }, payload = {}) {
            commit('setSearchParams', payload)
            dispatch("updatePageParams", {pageNo: 1})
            dispatch("fetchList")
        },
        updateSortParams({ commit, dispatch, state }, payload = {}) {
            if (state.sortParams.sort === payload.sort && state.sortParams.direction === payload.direction) {
                return false;
            }
            commit('setSortParams', payload)
            dispatch("updatePageParams", {pageNo: 1})
            dispatch("fetchList")
        },
        checkItem({ commit, state }, payload = {}) {
            let arr = [...state.selectedItems];
            let existIndex = arr.findIndex(({baseItemId}) => baseItemId === payload.baseItemId)
            if (existIndex > -1) {
                arr.splice(existIndex, 1)
            } else {
                arr.push (payload)
            }
            commit('setSelectedItems', arr)
        },
        checkPageAllItem({ commit, state }) {
            if (state.selectedItems.length === state.list.length) {
                commit('setSelectedItems', [])
            } else {
                commit('setSelectedItems', state.list)
            }
        },
        queryDisplayRackClassifyList({ commit, getters, dispatch }) {
            queryBaseItemDisplay().then(res => {
                if (res) {
                    commit('setDisplayRackClassifyList', res);
                }
            })
        },
        updateFreightModalParams({ commit, state }, payload = {}){
            commit('setFreightModalParams', {
                ...state.freightModal,
                ...payload
            })
        }
    },
    getters: {
        requestParams(state) {
            const {filterParams, searchParams, sortParams, pageParams} = state
            return {
                ...filterParams,
                ...searchParams,
                ...sortParams,
                ...pageParams
            }
        },
        isFirstRequest(state) {
            const {filterParams, searchParams, sortParams} = state
            return _.isEmpty(filterParams) && _.isEmpty(searchParams) && _.isEmpty(sortParams)
        },
        isCheckedPageAllItem(state) {
            return state.list.length && (state.selectedItems.length === state.list.length);
        },
        isCheckedItem(state) {
            return (data = {}) => {
                return state.selectedItems.findIndex(({baseItemId}) => baseItemId === data.baseItemId) > -1
            }
        },
        // 当前item的前一条数据
        preItemBy(state) {
            return (data = {}) => {
                let index = state.list.findIndex(({baseItemId}) => baseItemId === data.baseItemId)
                if (index === -1 || index === 0) return null
                return state.list[index - 1]
            }
        },
        // 当前item的后一条数据
        nextItemBy(state) {
            return (data = {}) => {
                let index = state.list.findIndex(({baseItemId}) => baseItemId === data.baseItemId)
                if (index === -1 || index === state.list.length - 1) return null
                return state.list[index + 1]
            }
        }
    }
}

export default commodityGoodsList
